import React, { useEffect, useState } from 'react'
import './RoleCreationForm.scss'
import { Box } from '@mui/system';
import { useFormik } from 'formik';
import { cfpBaseUrl } from '../../../../network/urls';
import * as Yup from "yup";
import { Backdrop, Grid, Typography } from '@mui/material';
import { Button, TextField } from '@mui/material';
import Radio from '@mui/material/Radio';
import CloseIcon from '@mui/icons-material/Close';
import pdfIcon from "../../../../images/pdfIcon.png";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { allCFCLevelsAPI, allEmployeeRoleTypes, handleFileUpload, isImage, isPdf } from '../../../../services/Functions';
import Error from '../../../../components/error/error';
import { useSelector } from 'react-redux';
import { AllPermissions } from '../../../../network/APIs/APIs';
import { documentExtensions } from '../../../../utils/PortalName';
const initialValues = {
    iv_roleName: "",
    iv_level: '',
    iv_status: 1,
    iv_type: '1',
    iv_due_date_extension_range: '',
    iv_installments_range: '',
    iv_show_all_applications: 0,
    iv_assigning_order_no: '',
    iv_assigning_authority: '',
    iv_assigining_date: '',
    iv_assigining_order_image: ''
}

const dueDatePermissionId = 104;
const installmentPermissionId = 105;

const RoleCreationForm = () => {

    const [status, setStatus] = useState(1);
    const [roleTypes, setRoleTypes] = useState()
    const [applicationsAppliedLoadFilter, setApplicationsAppliedLoadFilter] = useState(0);
    const [sortedPermissions, setSortedPermissions] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
    const [orderImage, setOrderImage] = useState()
    const [orderImageError, setOrderImageError] = useState()
    const [orderImageThumbnail, setOrderImageThumbnail] = useState()
    const [showDDBillAmountRange, setShowDDBillAmountRange] = useState(false);
    const [showInsBillAmountRange, setShowInsBillAmountRange] = useState(false);
    const [error, setError] = useState('')
    const [viewBackdrop, setViewBackdrop] = React.useState(false);
    const [cfcLevelList, setCFCLevelList] = useState([]);

    const [technicalLevels, setTechnicalLevels] = useState([{
        value: 1,
        label: 'PITC'
    }, {
        value: 2,
        label: 'DISCO'
    }, {
        value: 3,
        label: 'Circle'
    }, {
        value: 4,
        label: 'Division'
    }, {
        value: 52,
        label: 'Sub Division'
    }])

    const navigate = useNavigate();

    let { token, userId, permissions, hierarchy } = useSelector((state) => state.auth)

    const OrderImage = (event) => {
        if (event.target.files) {
            const newFileName = 'orderImage.' + event.target.files[0].name.split(".").pop();
            handleFileUpload(event, handleChange, setOrderImage, setOrderImageError, setOrderImageThumbnail, newFileName);
        }
    }

    const errorCloses = () => {
        setError('')
    }

    useEffect(() => {
        const getAllPermissions = async () => {
            setViewBackdrop(true)
            let { sortedAllPermissions } = await AllPermissions(token, permissions)
            setSortedPermissions(sortedAllPermissions)
            setViewBackdrop(false)
        }
        getAllPermissions()
    }, [])

    useEffect(() => {
        if (hierarchy != 1) {
            let hierarchyArray = technicalLevels
            setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
        }
    }, [hierarchy])

    useEffect(() => {
        const callCFCLevels = async () => {
            setViewBackdrop(true)
            let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
            if (cfcLevelsList) {
                if (hierarchy != 1) {
                    cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
                }
                setCFCLevelList(cfcLevelsList)
            }
            setViewBackdrop(false);
        }
        callCFCLevels()
    }, [])

    useEffect(() => {
        const getAllEmployeeRoleTypes = async () => {
            setViewBackdrop(true)
            let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
            if (employeeRoleTypes) {
                setRoleTypes(employeeRoleTypes)
            }
            setViewBackdrop(false);
        }
        getAllEmployeeRoleTypes()
    }, [])

    const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_type: Yup.mixed().required('Select role type.'),
            iv_roleName: Yup.string().required("Role name is required.").min(3, `Name can't be less than 3 characters!`),
            iv_show_all_applications: Yup.number().required('Show all applications is required.'),
            iv_assigning_order_no: Yup.string().required("Order No. is required."),
            iv_assigning_authority: Yup.string().required("Order authority is required."),
            iv_assigining_date: Yup.date().required("Order date is required.").max(new Date(), 'Order date must be in the past!'),
            iv_assigining_order_image: Yup.string().required('Upload order image.')
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoadingSpinner(true);
            var formdata = new FormData();
            formdata.append("roleName", values.iv_roleName);
            formdata.append("level", values.iv_level);
            formdata.append("status", values.iv_status);
            formdata.append("roleTypeId", values.iv_type);
            formdata.append("createdBy", userId);
            checkedItems.forEach(item => {
                formdata.append("permissions", item)
            })
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;
            formdata.append("showAllApplicationsFlag", values.iv_show_all_applications);
            formdata.append("premAsigningOrderNo", values.iv_assigning_order_no);
            formdata.append("premAsigningOrderAuthority", values.iv_assigning_authority);
            formdata.append("premAsigningOrderDate", values.iv_assigining_date);
            formdata.append("premAsigningOrderImage", orderImageThumbnail);

            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };

            await fetch(cfpBaseUrl + "role/addRole", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === '200') {
                        let roleId = result.roleId
                        setIsLoadingSpinner(false);
                        var formdata = new FormData();
                        const myHeaders = new Headers();
                        myHeaders.append("Authorization", token);;

                        var requestOptions = {
                            method: 'POST',
                            body: formdata,
                            headers: myHeaders,
                            redirect: 'follow',
                        };

                        fetch(cfpBaseUrl + "role/getAllRoles", requestOptions)
                            .then(response => response.json())
                            .then(result => {
                                if (result.status === "200") {
                                    navigate('/role-management')
                                }
                            }
                            )
                            .catch(error => console.log('error', error));
                        // toast.success(result.message)
                    }
                    else {
                        setIsLoadingSpinner(false);
                    }
                })
                .catch(error => {
                    setIsLoadingSpinner(false);
                }
                );
            setCheckedItems([]);
            resetForm();
        }

    });

    const dueDateRangeFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_due_date_extension_range: Yup.string().when('showDDBillAmountRange', {
                is: (showDDBillAmountRange) => (showDDBillAmountRange === true),
                then: Yup.string().required('Select amount range for due date extension.'),
                otherwise: Yup.string().optional()
            })
        }),
        onSubmit: (values, { resetForm }) => {
            installmentsRangeFormik.handleSubmit()
        }
    })

    const installmentsRangeFormik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            iv_installments_range: Yup.string().when('showInsBillAmountRange', {
                is: (showInsBillAmountRange) => (showInsBillAmountRange === true),
                then: Yup.string().required('Select amount range for installments.'),
                otherwise: Yup.string().optional()
            })
        }),
        onSubmit: (values, { resetForm }) => {
            //API for due date range submission
        }
    })

    function CheckboxItem({ item, onCheck, checkedItems }) {
        const { idt, name, children } = item;

        function handleCheck(event) {
            const isChecked = event.target.checked;
            onCheck(item, isChecked);
        }

        // Determine if this item is checked based on its id
        const isChecked = checkedItems.includes(idt);

        return (
            <Grid container >
                <Grid item sx={item.children != null ? { border: '1px solid lightGrey', borderRadius: '5px', padding: '10px', margin: '5px', backgroundColor: '#EEF1F7' } : { padding: '2px', margin: '2px' }}>
                    <Grid container display='flex' justifyContent='space-between'>
                        <Grid item xs={2}>
                            <input type="checkbox" checked={isChecked} onChange={handleCheck} />
                        </Grid>
                        <Grid item xs={10}>
                            <label style={{ marginLeft: '5px' }}>
                                {name}
                            </label>
                        </Grid>
                    </Grid>
                    {children && children.length > 0 && (
                        <div style={{ marginLeft: '20px', }}>
                            {children.map(child => (
                                <>
                                    <CheckboxItem key={child.idt} item={child} onCheck={onCheck} checkedItems={checkedItems} />
                                </>
                            ))}
                        </div>
                    )}

                </Grid>
            </Grid>
        );
    }

    function CheckboxHierarchy({ data }) {

        function handleCheck(item, isChecked) {

            // Update the checked items array
            let newCheckedItems = [...checkedItems];

            // If the item is being checked, add its id to the checked items array
            // and check all its children and grandchildren
            if (isChecked) {
                newCheckedItems.push(item.idt);
                if (item.idt === dueDatePermissionId) {
                    setShowDDBillAmountRange(true)
                }
                if (item.idt === installmentPermissionId) {
                    setShowInsBillAmountRange(true)
                }
                checkChildrenAndGrandchildren(item, newCheckedItems);
            }
            // If the item is being unchecked, remove its id from the checked items array
            // and uncheck all its children and grandchildren
            else {
                if (item.idt === dueDatePermissionId) {
                    setShowDDBillAmountRange(false)
                    dueDateRangeFormik.resetForm()
                }
                if (item.idt === installmentPermissionId) {
                    setShowInsBillAmountRange(false)
                    installmentsRangeFormik.resetForm()
                }
                newCheckedItems = uncheckChildrenAndGrandchildren(item, newCheckedItems);
                newCheckedItems = newCheckedItems.filter((checkedItem) => checkedItem !== item.idt);
            }
            setCheckedItems(newCheckedItems);
        }

        // Recursive function to check all children and grandchildren of an item
        function checkChildrenAndGrandchildren(item, checkedItems) {
            if (item.children) {
                item.children.forEach((child) => {
                    if (child.idt === dueDatePermissionId) {
                        setShowDDBillAmountRange(true)
                    }
                    if (child.idt === installmentPermissionId) {
                        setShowInsBillAmountRange(true)
                    }
                    checkedItems.push(child.idt);
                    checkChildrenAndGrandchildren(child, checkedItems);
                });
            }
        }

        // Recursive function to uncheck all children and grandchildren of an item
        function uncheckChildrenAndGrandchildren(item, checkedItems) {
            if (item.children) {
                item.children.forEach((child) => {
                    if (child.idt === dueDatePermissionId) {
                        setShowDDBillAmountRange(false)
                        dueDateRangeFormik.resetForm()
                    }
                    if (child.idt === installmentPermissionId) {
                        setShowInsBillAmountRange(false)
                        installmentsRangeFormik.resetForm()
                    }
                    checkedItems = uncheckChildrenAndGrandchildren(child, checkedItems);
                    checkedItems = checkedItems.filter((checkedItem) => checkedItem !== child.idt);
                });
            }
            return checkedItems;
        }



        return (
            <Grid container display='flex'>
                {
                    data.map(rootItem => (
                        <Grid item>
                            <CheckboxItem key={rootItem.idt} item={rootItem} onCheck={handleCheck} checkedItems={checkedItems} />
                        </Grid>
                    ))
                }
            </Grid>

        );
    }

    const Status = (event) => {
        setStatus(event.target.value)
        values.iv_status = event.target.value
    }

    const ApplicationsAppliedLoadFilter = (event) => {
        setApplicationsAppliedLoadFilter(event.target.value)
        values.iv_show_all_applications = event.target.value
    }

    return (
        <>
            <Grid container className='roleCreation'>
                <Box className='roleCreationContainer'>
                    <h3 className='heading'>
                        Role Creation Form
                    </h3>
                    <form className='ncform'>
                        <Grid container>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Role Type</label>
                                <FormControl className='form-control' >
                                    <RadioGroup
                                        className='radio-group'
                                        row
                                        name="iv_type"
                                        defaultValue={values.iv_type}
                                        value={values.iv_type}
                                        onChange={handleChange}
                                    >
                                        {roleTypes && roleTypes.map((item) => {
                                            return <FormControlLabel
                                                value={item.roleTypeId}
                                                className='form-control-label'
                                                control={<Radio />}
                                                label={item.roleTypeName}
                                                labelPlacement="end"
                                            />
                                        })}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Role Name</label>
                                <TextField
                                    type='text'
                                    name="iv_roleName"
                                    autoComplete='off'
                                    value={values.iv_roleName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_roleName"
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {errors.iv_roleName && touched.iv_roleName ? (errors.iv_roleName) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Status</label>
                                <FormControl className='form-control' >
                                    <RadioGroup
                                        className='radio-group'
                                        row
                                        name="iv_status"
                                        defaultValue={status}
                                        value={status}
                                        onChange={Status}
                                    >
                                        <FormControlLabel
                                            value={1}
                                            className='form-control-label'
                                            control={<Radio />}
                                            label="Active"
                                            name='active'
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value={2}
                                            className='form-control-label'
                                            control={<Radio />}
                                            label="Inactive"
                                            name='inactive'
                                            labelPlacement="end"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Show All Applications</label>
                                <FormControl className='form-control' >
                                    <RadioGroup
                                        className='radio-group'
                                        row
                                        name="iv_show_all_applications"
                                        defaultValue={applicationsAppliedLoadFilter}
                                        value={applicationsAppliedLoadFilter}
                                        onChange={ApplicationsAppliedLoadFilter}
                                    >
                                        <FormControlLabel
                                            value={1}
                                            className='form-control-label'
                                            control={<Radio />}
                                            label="Yes"
                                            name='yes'
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value={0}
                                            className='form-control-label'
                                            control={<Radio />}
                                            label="No"
                                            name='no'
                                            labelPlacement="end"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            {
                                values.iv_type == '1' &&
                                < Grid item xs={3}>
                                    <label className='fieldLabel' >Level</label>
                                    <Select
                                        autoWidth={false}
                                        value={values.iv_level}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        displayEmpty
                                        name="iv_level"
                                        size='small'
                                        id="iv_level"
                                        className='dropdownList'
                                    >
                                        <MenuItem value=''>Select Level</MenuItem>
                                        {
                                            cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                                        }
                                    </Select>
                                </Grid>
                            }
                            {
                                values.iv_type == '2' &&
                                < Grid item xs={3}>
                                    <label className='fieldLabel' >Level</label>
                                    <Select
                                        autoWidth={false}
                                        value={values.iv_level}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        displayEmpty
                                        name="iv_level"
                                        size='small'
                                        id="iv_level"
                                        className='dropdownList'
                                    >
                                        <MenuItem value=''>Select Level</MenuItem>
                                        {
                                            technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                                        }
                                    </Select>
                                </Grid>
                            }
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Order No.</label>
                                <TextField
                                    type='text'
                                    name="iv_assigning_order_no"
                                    autoComplete='off'
                                    value={values.iv_assigning_order_no}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_assigning_order_no"
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {errors.iv_assigning_order_no && touched.iv_assigning_order_no ? (errors.iv_assigning_order_no) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Order Authority</label>
                                <TextField
                                    type='text'
                                    name="iv_assigning_authority"
                                    autoComplete='off'
                                    value={values.iv_assigning_authority}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_assigning_authority"
                                    className='textInputField'
                                />
                                <Box className='from-Error'>
                                    {errors.iv_assigning_authority && touched.iv_assigning_authority ? (errors.iv_assigning_authority) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Order Date</label>
                                <input
                                    type='date'
                                    name="iv_assigining_date"
                                    value={values.iv_assigining_date}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    id="iv_assigining_date"
                                    className='dateInputField'
                                    max={new Date().toISOString().split('T')[0]}
                                />
                                <Box className='from-Error'>
                                    {errors.iv_assigining_date && touched.iv_assigining_date ? (errors.iv_assigining_date) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={3}>
                                <label className='fieldLabel' >Order Image</label>
                                <Box className='from-Error'>
                                    {errors.iv_assigining_order_image && touched.iv_assigining_order_image ? (errors.iv_assigining_order_image) : null}
                                </Box>
                                <Grid item lg={2}>
                                    {orderImage ? (
                                        <>
                                            <Button
                                                component="label"
                                                startIcon={
                                                    <CloseIcon
                                                        className="button-with-image"
                                                        onClick={() => {
                                                            setOrderImage("");
                                                        }}
                                                    />
                                                }
                                            >
                                                {orderImageThumbnail &&
                                                    isImage(orderImage) ? (
                                                    <div className="btn-div">
                                                        <img
                                                            src={orderImageThumbnail}
                                                            alt="Order Image"
                                                            width="80"
                                                        />
                                                    </div>
                                                ) : (
                                                    <span>
                                                        {isPdf(orderImage) ? (
                                                            <div className="btn-div">
                                                                <img src={pdfIcon} alt="PDF" width="80" />
                                                                {/* <p>{orderImageFileName}</p> */}
                                                            </div>
                                                        ) : (
                                                            "Other file type"
                                                        )}
                                                    </span>
                                                )}
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                startIcon={<FileUploadOutlinedIcon />}
                                                className="btn"
                                            >
                                                Upload
                                                <input
                                                    hidden
                                                    accept={documentExtensions}
                                                    id="iv_assigining_order_image"
                                                    name="iv_assigining_order_image"
                                                    type="file"
                                                    onChange={OrderImage}
                                                />
                                            </Button>
                                            <Box className='from-Error'>
                                                {orderImage == '' ?
                                                    orderImageError : null
                                                }
                                            </Box>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <label className='fieldLabel'>
                            Permissions
                        </label>
                        <div style={{ marginLeft: '10px' }}>
                            <CheckboxHierarchy data={sortedPermissions} />
                        </div>
                        <Box className='from-Error'>
                            <ul>
                                {
                                    errors.iv_roleName && touched.iv_roleName ?
                                        <li>
                                            {(errors.iv_roleName)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_status && touched.iv_status ?
                                        <li>
                                            {(errors.iv_status)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_show_all_applications && touched.iv_show_all_applications ?
                                        <li>
                                            {(errors.iv_show_all_applications)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_level && touched.iv_level ?
                                        <li>
                                            {(errors.iv_level)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_assigning_order_no && touched.iv_assigning_order_no ?
                                        <li>
                                            {(errors.iv_assigning_order_no)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_assigning_authority && touched.iv_assigning_authority ?
                                        <li>
                                            {(errors.iv_assigning_authority)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_assigining_date && touched.iv_assigining_date ?
                                        <li>
                                            {(errors.iv_assigining_date)}
                                        </li> :
                                        <>
                                        </>
                                }
                                {
                                    errors.iv_assigining_order_image && touched.iv_assigining_order_image ?
                                        <li>
                                            {(errors.iv_assigining_order_image)}
                                        </li> :
                                        <>
                                        </>
                                }
                            </ul>
                        </Box>
                        {
                            error &&
                            <div style={{ margin: '15px' }}>
                                <Error
                                    error={error}
                                    onClose={() => errorCloses()}
                                    backgroundColor="#FFC0CB"
                                    textColor="#bb0303"
                                    iconColor="#bb0303"
                                />
                            </div>
                        }
                        <Box sx={{ margin: '1%' }}>
                            <Button sx={{ width: '10%', float: 'right' }} variant="contained" size='medium' onClick={handleSubmit} disabled={isLoadingSpinner}>
                                {isLoadingSpinner ? (
                                    <Box sx={{ display: 'flex' }}>
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Box>
                    </form >
                </Box >
            </Grid >

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }
                }
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default RoleCreationForm
